import React from 'react';
import { BaseComponent } from 'kryfe-lib';
import { Button, Select, Input, Icon } from 'antd';
import * as regExpDefault from 'shared/regExp';
import { UeAddParams, baiduTrackEvent } from 'shared/utils/commonUtil';

import './index.less';

const Option = Select.Option;
const regExp = regExpDefault.default;

const judgeLimitStep = [
  {
    className: 'judgeLimitStepOne',
    next: 'judgeLimitStepTwo',
    question: '您的职业身份？',
    type: 'profession',
    progressBar: {
      dot: 1,
      line: 0,
    },
    content: {
      value: true,
      btn: [
        {
          value: 1,
          text: '商家',
        },
        {
          value: 2,
          text: '工薪族',
        },
      ],
    },
  },
  {
    className: 'judgeLimitStepTwo',
    prev: 'judgeLimitStepOne',
    next: 'judgeLimitStepThree',
    question: '您的年龄？',
    type: 'age',
    progressBar: {
      dot: 2,
      line: 1,
    },
    content: {
      value: true,
      btn: [
        {
          value: 1,
          text: '20-29',
        },
        {
          value: 2,
          text: '30-39',
        },
        {
          value: 2,
          text: '40-49',
        },
        {
          value: 2,
          text: '50-60',
        },
      ],
    },
  },
  {
    className: 'judgeLimitStepThree',
    prev: 'judgeLimitStepTwo',
    next: 'judgeLimitStepFour',
    question: '您有信用卡吗？',
    type: 'useCreditCard',
    progressBar: {
      dot: 3,
      line: 2,
    },
    content: {
      value: true,
      btn: [
        {
          value: 1,
          text: '有',
        },
        {
          value: 0,
          text: '没有',
        },
      ],
    },
  },
  {
    className: 'judgeLimitStepFour',
    prev: 'judgeLimitStepThree',
    next: 'judgeLimitResult',
    question: '您的月收入？',
    type: 'monthlyIncome',
    progressBar: {
      dot: 4,
      line: 3,
    },
    content: {
      value: false,
    },
  },
];

const income = [
  { low: 1000, high: 3000, value: 1 },
  { low: 3000, high: 5000, value: 2 },
  { low: 5000, high: 8000, value: 3 },
  { low: 8000, high: 10000, value: 4 },
  { low: 10000, high: 15000, value: 5 },
  { low: 15000, high: 20000, value: 6 },
  { low: 20000, high: 50000, value: 7 },
  { low: 50000, value: 8 },
];

class JudgeLimit extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      judgeLimitStart: true,
      judgeLimitStepOne: false,
      judgeLimitStepTwo: false,
      judgeLimitStepThree: false,
      judgeLimitStepFour: false,
      judgeLimitResult: false,

      // 用于返回上次tab
      profession: '',
      age: '',
      useCreditCard: '',
      monthlyIncome: '',
      iconType: 'left-circle-o',
      cellPhone: '',
    };
  }

  // 构建进度条UI
  progressBar = item => {
    let dot = item.dot;
    let line = item.line;
    let result = [];
    for (let i = 0; i < 4; i++) {
      let classNameDot = dot > 0 ? 'dot dot-o' : 'dot ';
      let classNameLine = line > 0 ? 'dashed line' : 'dashed';
      result.push(
        <div className={classNameDot} key={`${item.type}${i}Doc`} />,
        <div className={classNameLine} key={`${item.type}${i}Line`} />
      );
      dot--;
      line--;
    }
    // 循环完毕出栈最后一个元素
    result.pop();
    return result;
  };

  // 开始评估
  startJudge = () => {
    baiduTrackEvent('额度评估', '点击', '开始评估');
    this.setState({
      judgeLimitStart: false,
      judgeLimitStepOne: true,
    });
  };
  // iconType变化
  iconTypeMouseOver = () => {
    this.setState({
      iconType: 'left-circle',
    });
  };
  iconTypeMouseOut = () => {
    this.setState({
      iconType: 'left-circle-o',
    });
  };

  // autoJump为false，表示是否点击之后，立即跳转
  onChange = (type, value, next, className, autoJump = true) => {
    if (autoJump) {
      this.setState({
        [type]: value,
        [next]: true,
        [className]: false,
      });
    } else {
      this.setState({
        [type]: value,
      });
    }
  };

  // 返回上一个页面
  jumpToPrev = (className, prev, type) => {
    // 清除本页面和上个页面的值
    let prevArg = judgeLimitStep.find(currentValue => {
      if (currentValue.className == prev) {
        return currentValue;
      }
    });
    this.setState({
      [prev]: true,
      [className]: false,
      [prevArg.type]: '',
      [type]: '',
    });
    // 如果返回上一个页面为judgeLimitStepOne，则重置iconType，
    // 因为judgeLimitStepOne，没有返回按钮，导致iconType一直为eft-circle
    if (prev == 'judgeLimitStepOne') {
      this.setState({
        iconType: 'left-circle-o',
      });
    }
  };

  // 跳转结果页面,获取额度
  jumpToResult = (next, className) => {
    let ueAddParams = UeAddParams();
    this.setState({
      [next]: true,
      [className]: false,
    });
    this.props._judgeLimit({
      ...ueAddParams,
      profession: this.state.profession,
      age: this.state.age,
      useCreditCard: this.state.useCreditCard,
      monthlyIncome: this.state.monthlyIncome,
    });
  };

  // 计算结果
  calculate = () => {
    let arg = income.find(currentValue => {
      if (currentValue.value == this.state.monthlyIncome) {
        return currentValue;
      }
    });
    if (arg.low === 50000) {
      return '最高200';
    }
    let lowResult = arg.low * 10 / 10000;
    let highResult = arg.high * 30 / 10000;
    return `${lowResult}-${highResult}`;
  };

  // 输入手机号，判断是否可以提交
  inputPhone = e => {
    this.setState({
      cellPhone: e.target.value,
    });
  };

  // 提交申请
  submit = () => {
    baiduTrackEvent('额度评估', '点击', '立即申请');
    let ueAddParams = UeAddParams();
    let submitSucc = () => {
      this.setState({
        cellPhone: '',
      });
    };
    this.props._judgeLimitPhone(
      {
        ...ueAddParams,
        profession: this.state.profession,
        age: this.state.age,
        useCreditCard: this.state.useCreditCard,
        monthlyIncome: this.state.monthlyIncome,
        cellPhone: this.state.cellPhone,
      },
      submitSucc
    );
  };

  // 重新评估
  resetJudge = () => {
    this.setState({
      judgeLimitResult: false,
      judgeLimitStepOne: true,
      profession: '',
      age: '',
      useCreditCard: '',
      monthlyIncome: '',
      cellPhone: '',
    });
  };

  render() {
    return (
      <React.Fragment>
        <div className="inner">
          <div className="box">
            <div className="title">
              {this.state.judgeLimitResult == true
                ? '您的贷款额度为'
                : '在线评估，5秒获取额度'}
            </div>
            <div className="content">
              {this.state.judgeLimitStart ? (
                <div className="judgeLimitStart">
                  <div className="description">
                    <p className="tip">最高可贷</p>
                    <p className="detail">
                      <span className="number">200</span>
                      <span className="numberTitle">万</span>
                    </p>
                  </div>
                  <div className="operation">
                    <Button
                      type="primary"
                      style={{
                        width: 320,
                        height: 56,
                        borderRadius: 4,
                        fontSize: '20px',
                      }}
                      onClick={this.startJudge}
                    >
                      开始评估
                    </Button>
                  </div>
                </div>
              ) : null}
              {judgeLimitStep.map(
                (item, index) =>
                  this.state[item.className] ? (
                    <div className={item.className} key={item.className}>
                      <div className="description">
                        {item.prev ? (
                          <Icon
                            className="icon"
                            type={this.state.iconType}
                            style={{
                              position: 'absolute',
                              left: -78,
                              bottom: 16,
                              fontSize: 30,
                              color: '#258FF8',
                            }}
                            onMouseOver={this.iconTypeMouseOver}
                            onMouseOut={this.iconTypeMouseOut}
                            onClick={e => {
                              this.jumpToPrev(
                                item.className,
                                item.prev,
                                item.type
                              );
                            }}
                          />
                        ) : null}
                        <div className="progressBar">
                          {this.progressBar(item.progressBar)}
                        </div>
                        <div className="question">
                          <span className="number">{index + 1}.</span>
                          {item.question}
                        </div>
                      </div>
                      <div className="operation">
                        {item.content.value ? (
                          item.content.btn.map(itemBtn => (
                            <Button
                              key={itemBtn.text}
                              type="primary"
                              style={{
                                width: 100,
                                height: 40,
                                marginLeft: 24,
                                borderRadius: 4,
                              }}
                              onClick={e => {
                                this.onChange(
                                  item.type,
                                  itemBtn.value,
                                  item.next,
                                  item.className
                                );
                              }}
                            >
                              {itemBtn.text}
                            </Button>
                          ))
                        ) : (
                          <React.Fragment>
                            <Select
                              style={{ width: 240, display: 'block' }}
                              size="large"
                              placeholder="请选择"
                              onChange={value => {
                                this.onChange(
                                  item.type,
                                  value,
                                  item.next,
                                  item.className,
                                  false
                                );
                              }}
                            >
                              {income.map((itemIncome, index) => (
                                <Option
                                  value={itemIncome.value}
                                  key={itemIncome.low}
                                >
                                  {itemIncome.low === 50000
                                    ? '50000以上'
                                    : `${itemIncome.low}-${itemIncome.high}`}
                                </Option>
                              ))}
                            </Select>
                            <Button
                              type="primary"
                              style={{
                                width: 240,
                                height: 40,
                                marginTop: 25,
                                borderRadius: 4,
                              }}
                              onClick={e => {
                                this.jumpToResult(item.next, item.className);
                              }}
                              disabled={this.state.monthlyIncome ? false : true}
                            >
                              获取额度
                            </Button>
                          </React.Fragment>
                        )}
                      </div>
                    </div>
                  ) : null
              )}
              {this.state.judgeLimitResult ? (
                <div className="judgeLimitResult">
                  <div className="description">
                    <div className="result">
                      <span className="number">{this.calculate()}</span>万
                    </div>
                    <div className="tip">具体额度以您的实际风险评估为准</div>
                  </div>
                  <div className="operation">
                    <Input
                      value={this.state.cellPhone}
                      maxLength={11}
                      prefix={
                        <Icon
                          type="mobile"
                          style={{ color: 'rgba(0,0,0,.25)' }}
                        />
                      }
                      style={{
                        display: 'block',
                        width: 240,
                      }}
                      placeholder="请输入您的手机号码"
                      size="large"
                      onChange={this.inputPhone}
                    />
                    <Button
                      type="primary"
                      style={{
                        width: 240,
                        height: 40,
                        marginTop: 25,
                        marginRight: 24,
                        borderRadius: 4,
                      }}
                      onClick={this.submit}
                      disabled={
                        regExp.phone.test(this.state.cellPhone) ? false : true
                      }
                    >
                      立即申请
                    </Button>
                    <a onClick={this.resetJudge}>重新评估</a>
                  </div>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default JudgeLimit;



// WEBPACK FOOTER //
// ./src/pages/newHome/components/parts/judgeLimit.jsx